<template>
  <div class="order-notice pass-notice">
    <div class="status-banner pass">
      <div class="banner-title">{{ payload.title || '订舱申请已放舱' }}</div>
      <div class="banner-sub">{{ payload.titleInfo || '' }}</div>
    </div>

    <div class="section">
      <div class="section-label">放舱信息</div>
      <div class="reason-box">{{ payload.content || '—' }}</div>
    </div>

    <div class="meta-row">
      <div class="meta-item">
        <div class="meta-label">订单号</div>
        <div class="meta-value">{{ payload.orderNo || '—' }}</div>
      </div>
      <div class="meta-item">
        <div class="meta-label">船期</div>
        <div class="meta-value">{{ payload.scheduleInfo || '—' }}</div>
      </div>
    </div>

    <div class="notice-actions">
      <el-button @click="$emit('view-order')">查看订单</el-button>
      <el-button type="primary" @click="$emit('read')">已读</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PassOrderNotice',
  props: {
    payload: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style scoped>
.order-notice {
  padding: 4px 4px 0;
}
.status-banner {
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 16px;
}
.status-banner.pass {
  background: #f6ffed;
  border: 1px solid #b7eb8f;
}
.banner-title {
  font-size: 15px;
  font-weight: 700;
  color: #389e0d;
  margin-bottom: 6px;
  line-height: 1.4;
}
.banner-sub {
  font-size: 13px;
  color: #237804;
  line-height: 1.4;
  opacity: 0.9;
}
.section-label {
  font-size: 12px;
  color: #8f959e;
  margin-bottom: 8px;
}
.reason-box {
  min-height: 48px;
  padding: 12px 14px;
  border: 1px solid #e8ebf0;
  border-radius: 8px;
  background: #fafbfc;
  color: #1f2329;
  font-size: 13px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}
.meta-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
}
.meta-label {
  font-size: 12px;
  color: #8f959e;
  margin-bottom: 4px;
}
.meta-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2329;
  word-break: break-all;
}
.notice-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}
</style>
